import { Modal } from 'bootstrap';

export function appendTo(node, html) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    node.appendChild(template.content.firstChild);
}

export function prependTo(node, html) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    node.prepend(template.content.firstChild);
}

export function getFormData(object) {
    const formData = new FormData();

    if (object) {
        Object.keys(object)
            .forEach((key) => {
                formData.append(key, object[key]);
            });
    }

    return formData;
}

export function getNextSibling(elem, selector) {
    const nextElem = elem.nextElementSibling;

    if (!selector) {
        return nextElem;
    }

    if (nextElem && nextElem.matches(selector)) {
        return nextElem;
    }

    return null;
}

export function scrollToElement(element, yOffset = 0) {
    window.scrollTo({
        top: element.getBoundingClientRect().top + window.pageYOffset + yOffset,
        behavior: 'smooth',
    });
}

export function parseJson(jsonString) {
    try {
        const o = JSON.parse(jsonString);

        // Handle non-exception-throwing cases:
        // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
        // but... JSON.parse(null) returns null, and typeof null === "object",
        // so we must check for that, too. Thankfully, null is falsey, so this suffices:
        if (o && typeof o === 'object') {
            return o;
        }
        // eslint-disable-next-line no-empty
    } catch (e) {
    }

    return false;
}

export async function bootstrapConfirm(config) {
    const modalElement = document.createElement('div');

    let icon;
    let buttons;
    let message = '';

    if (config.message === 'unknown') {
        config.title = 'Что-то пошло не так';
        config.message = 'Мы уже получили сообщение об ошибке и работаем над этим.';
    }

    if (typeof config.title !== 'undefined') {
        message += `<p class="h5">${config.title}</p>`;
    }

    message += `<p class="mb-0">${config.message}</p>`;

    switch (config.button) {
        case 'delete':
            buttons = [
                '<button id="modal-btn-confirm" type="button" class="btn btn-delete">',
                '<svg class="icon small me-1" aria-hidden="true"><use xlink:href="#icon-trash-can"></use></svg> удалить',
                '</button>',
                '<button id="modal-btn-cancel" type="button" class="btn btn-cancel">отмена</button>',
            ].join('');
            break;
        case 'unlink':
            buttons = [
                '<button id="modal-btn-confirm" type="button" class="btn btn-delete">',
                '<svg class="icon small me-1" aria-hidden="true"><use xlink:href="#icon-link-slash"></use></svg> отвязать',
                '</button>',
                '<button id="modal-btn-cancel" type="button" class="btn btn-cancel">отмена</button>',
            ].join('');
            break;
        case 'ok':
            buttons = [
                '<button id="modal-btn-confirm" type="button" class="btn btn-ok">OK</button>',
            ].join('');
            break;
        default:
            buttons = [
                '<button id="modal-btn-confirm" type="button" class="btn btn-ok">закрыть</button>',
            ].join('');
            break;
    }

    modalElement.id = 'modal-confirm';
    modalElement.className = 'modal';
    modalElement.innerHTML = [
        '<div class="modal-dialog modal-dialog-centered modal-sm modal-confirm">',
        '<div class="modal-content user-select-none">',
        '<div class="modal-body">',
        `<div class="lh-sm text-center py-3 pb-2">${message}</div>`,
        '</div>',
        `<div class="modal-footer">${buttons}</div>`,
        '</div>',
        '</div>',
    ].join('');

    const bootstrapModal = new Modal(modalElement, {
        keyboard: false,
        backdrop: 'static',
    });
    bootstrapModal.show();
    document.querySelectorAll('.modal')
        .forEach((modal) => {
            if (modalElement != modal) {
                modal.classList.add('modal-off');
            }
        });

    return new Promise((resolve) => {
        function response(e) {
            let bool = false;
            if (e.target.id === 'modal-btn-cancel') {
                bool = false;
            } else if (e.target.id === 'modal-btn-confirm') {
                bool = true;
            } else {
                return;
            }

            document.body.removeEventListener('click', response);
            bootstrapModal.hide();
            modalElement.remove();
            resolve(bool);

            document.querySelectorAll('.modal')
                .forEach((modal) => {
                    modal.classList.remove('modal-off');
                });
        }

        document.body.addEventListener('click', response);
    });
}

export function reachYmTarget(name, data = {}) {
    if (typeof ym !== 'undefined') {
        ym(66083032, 'reachGoal', name, data);
    } else {
        console.warn(`Send ${name} event to ym`, data);
    }
}
